import { render } from "./SearchBarItem.vue?vue&type=template&id=0ce7cba6"
import script from "./SearchBarItem.vue?vue&type=script&lang=js"
export * from "./SearchBarItem.vue?vue&type=script&lang=js"
script.render = render

export default script